
































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RkDropdownItem extends Vue {
  @Prop({ default: false }) private detail!: boolean;
  @Prop() private active!: string | number;
  @Prop() private value!: string | number;
  private show: boolean = false;
}
